<template lang="pug">
login-wrapper(childClass="box-forgot")
  slot
        legend Забыли пароль?
        p Введите номер email и мы отправим Вам инструкцию для восстановления пароля.
        .form-group(:class="{'has-error': !valid}")
          .vfl-field.input-group(style="width: 100%;")
            input(type='text', 
                  v-model='email', 
                  required="", 
                  @focus="valid = true"
            )
            span.field-underline
            label Email
                span(v-if='!valid') <b> – обязательно </b>
        p(v-if="message") {{ message }}
        .form-actions
          router-link(:to="{name: 'Login'}").btn.btn-default
            | Вернуться ко входу
          button.btn.btn-primary.pull-right(@click.prevent="recoverPassword")
            | Восстановить 

</template>

<script>
import LoginWrapper from '@/components/auth/LoginWrapper';

export default {
    name: 'Recover',
    components: {
        LoginWrapper
    },
    methods: {
        validate() {
            return this.valid = /@/.test(this.email);
        },
        recoverPassword() {
            if (this.validate()) {
                this.$store.dispatch('sendRecoverPasswordLink', {
                    username_field: 'email',
                    username: this.email
                }).then(message => {
                    this.message = message;
                });
            }
        }
    },
    data() {
        return {
            email: null,
            valid: true,

            message: null
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/auth/Recover.vue